// Status mapping podle Brief & Design Manual §4.9.
// `status_label` přichází z DB view `partner_orders_view` jako jeden z těchto.

export type OrderStatus = "geplant" | "in_arbeit" | "abgeschlossen" | "reklamiert" | "storniert";

export type InvoiceStatus = "offen" | "bezahlt" | "überfällig";

interface StatusMeta {
  label: string;
  badgeClass: string; // Tailwind class kombinace pro <Badge>
  pulse?: boolean;
  lineThrough?: boolean;
}

export const ORDER_STATUS: Record<OrderStatus, StatusMeta> = {
  geplant: { label: "Geplant", badgeClass: "badge-blue badge-dot" },
  in_arbeit: { label: "In Arbeit", badgeClass: "badge-gold badge-pulse", pulse: true },
  abgeschlossen: { label: "Abgeschlossen", badgeClass: "" },
  reklamiert: { label: "Reklamiert", badgeClass: "badge-amber badge-dot" },
  storniert: { label: "Storniert", badgeClass: "badge-red badge-dot", lineThrough: true },
};

export const INVOICE_STATUS: Record<InvoiceStatus, StatusMeta> = {
  offen: { label: "Offen", badgeClass: "" },
  bezahlt: { label: "Bezahlt", badgeClass: "badge-green badge-dot" },
  überfällig: { label: "Überfällig", badgeClass: "badge-red badge-dot" },
};

export function orderStatusMeta(s: string | null | undefined): StatusMeta | null {
  if (!s) return null;
  return ORDER_STATUS[s as OrderStatus] ?? null;
}

export function invoiceStatusMeta(s: string | null | undefined): StatusMeta | null {
  if (!s) return null;
  return INVOICE_STATUS[s as InvoiceStatus] ?? null;
}
